import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from './avatar';

/* eslint-disable no-nested-ternary */
const Container = styled.div`
  display: flex;
  margin-bottom: ${props => (props.theme.isMobile ? (props.small ? 12 : 18) : (props.small ? 15 : 24))}px;
`;
/* eslint-enable no-nested-ternary */

const Name = styled.span`
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
`;

const Org = styled.span`
  font-weight: ${props => props.theme.fontWeightBold};
`;

const Profile = styled.div`
  ${props => (props.theme.isMobile ? `
    font-size: 13px;
    line-height: 15px;
  ` : `
    font-size: 16px;
    line-height: 18px;
  `)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-family: ${props => props.theme.fontFamilyBody};
  color: ${props => (props.dark ? props.theme.bodyColor : props.theme.secondaryColor)};

  > a {
    color: ${props => (props.dark ? props.theme.bodyColor : props.theme.secondaryColor)};
  }

  ${props => props.small && `
    justify-content: flex-start;
    & ${Name} {
      font-size: 14px;
      line-height: 15px;
    }

    & ${Org} {
      font-size: 12px;
      line-height: 12px;
    }
  `};
`;

export default function NanoProfile({ profile, dark, small }) {
  const url = `/contributors/${profile.slug}`;

  return (
    <Container small={small}>
      <Avatar profile={profile} size="xs" />
      <Profile dark={dark} small={small}>
        {profile.contributorOrEditor
          ? (<a href={url}><Name>{profile.name}</Name></a>)
          : (<Name>{profile.name}</Name>)}
        <Org>{profile.organisation}</Org>
      </Profile>
    </Container>
  );
}

NanoProfile.propTypes = {
  profile: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
    organisation: PropTypes.string,
    contributorOrEditor: PropTypes.bool.isRequired,
  }).isRequired,
  dark: PropTypes.bool,
  small: PropTypes.bool,
};

NanoProfile.defaultProps = {
  dark: false,
  small: false,
};
